export default {
  finance: {},
}
